import React from 'react';
import PropTypes from 'prop-types';
import { Shape as AuthShape } from 'lib/auth';
import UserShape from 'entities/user/shape';
import Providers from './Providers';

export default function Root({ auth, user, children }) {
  return (
    <Providers auth={auth} user={user}>
      {children}
    </Providers>
  );
}

Root.propTypes = {
  auth: AuthShape,
  user: UserShape,
  children: PropTypes.node.isRequired,
};
